import { render, staticRenderFns } from "./IconExpand.vue?vue&type=template&id=04d5e847&scoped=true"
import script from "./IconExpand.vue?vue&type=script&lang=js"
export * from "./IconExpand.vue?vue&type=script&lang=js"
import style0 from "./IconExpand.vue?vue&type=style&index=0&id=04d5e847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d5e847",
  null
  
)

export default component.exports